import { useEffect, useState } from 'react';

export function useVisibleTick(intervalMs: number): void {
  const [, setTick] = useState(0);

  useEffect(() => {
    let timer: ReturnType<typeof setInterval> | undefined;

    const stop = () => {
      clearInterval(timer);
      timer = undefined;
    };

    const start = () => {
      timer ??= setInterval(() => setTick((tick) => tick + 1), intervalMs);
    };

    const followVisibility = () => (document.hidden ? stop() : start());

    followVisibility();
    document.addEventListener('visibilitychange', followVisibility);

    return () => {
      stop();
      document.removeEventListener('visibilitychange', followVisibility);
    };
  }, [intervalMs]);
}
